import styled from 'styled-components';

const Wrapper = styled.div`
  padding: 20px;
  width: 100%;
  margin: 0 auto;
  @media (max-width: 768px) {
    padding: 0;
    width: auto;
  }
`;

const NavigationBar = styled.nav`
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
`;

const NavButton = styled.button<{ disabled: boolean }>`
  padding: 8px 16px;
  border-radius: ${({ theme }) => theme.borderRadius.xs};
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  background: ${({ theme, disabled }) =>
    disabled ? theme.colors.backgroundHover : theme.colors.background};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  opacity: ${(props) => (props.disabled ? 0.7 : 1)};

  &:hover:not(:disabled) {
    background: ${({ theme }) => theme.colors.backgroundHover};
  }
`;

const CompletionModalContent = styled.div`
  padding: 20px;

  h3 {
    color: ${({ theme }) => theme.colors.primary};
    margin-bottom: 16px;
  }

  .completion-summary {
    margin: 20px 0;

    .section-status {
      display: flex;
      justify-content: space-between;
      padding: 8px 0;
      border-bottom: 1px solid ${({ theme }) => theme.colors.border.light};
    }
  }

  .action-buttons {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 24px;

    button {
      padding: 8px 16px;
      border-radius: ${({ theme }) => theme.borderRadius.xs};
      border: 1px solid ${({ theme }) => theme.colors.primary};
      background: ${({ theme }) => theme.colors.background};
      cursor: pointer;

      &:hover {
        background: ${({ theme }) => `${theme.colors.primary}1a`};
      }

      &:first-child {
        background: ${({ theme }) => theme.colors.primary};
        color: ${({ theme }) => theme.colors.text.onDark ?? theme.colors.background};

        &:hover {
          background: ${({ theme }) => theme.colors.secondary};
        }
      }
    }
  }
`;

export const StyledComponents = {
  Wrapper,
  NavigationBar,
  NavButton,
  CompletionModalContent,
};
